import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import Loading from "../../../components/loading";
import associateServices from "../../../services";
import moment from "moment";
import InstrumentIcon from "../../../components/instrument-icon";
import Big from "big.js";
import NoData from "../../../components/no-data";
import {Tooltip} from "react-tooltip";
import FormButton from "../../../components/form-button";
import CLIPBOARD_HELPER from "../../../helpers/clipboard-helpers";
import RankIcon from "../../../components/rank-icon";
import SvgIcon from "../../../components/svg-icon";
import stringHelper from "../../../helpers/string-helper";

const BetDetailModal = props => {
    const {handleClose} = props
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language
    const [searchParams, setSearchParams] = useSearchParams()

    const [reference, setReference] = useState(false)
    const [loading, setLoading] = useState(true)
    // const [sum, setSum] = useState('')
    const [bet, setBet] = useState({})
    const [events, setEvents] = useState([])
    const location = useLocation()
    const navigate = useNavigate()

    // useEffect(() => {
    //     setSum(events?.reduce((n, {outcome_rate}) => n + parseFloat(outcome_rate), 0))
    // }, [events])

    useEffect(() => {
        if (reference) {
            const split = reference?.toString().split(':');

            if (split[0] === 'casino')
                getCasinoBetDetail(split[1])
            else if (split[0] === 'sportsbook')
                getSportsbookBetDetail(split[1])

        }
    }, [reference])

    const getCasinoBetDetail = (reference) => {
        associateServices.getDebitReference({
            reference
        }).then(res => {
            setBet(res?.data || {})
            setTimeout(() => setLoading(false), 260)
        })
    }
    const getSportsbookBetDetail = (reference) => {
        associateServices.getSportsbookDebitReference({
            reference
        }).then(res => {
            setBet(res?.data || {})
            setTimeout(() => setLoading(false), 260)
        })
    }
    const getParams = (key) => {
        const searchParams = new URLSearchParams(location?.search);
        return searchParams.get(key);
    }


    useEffect(() => {
        const bdy = document.body
        bdy.classList?.add('modal-open')

        const mdl = document.getElementById('gamebet-modal')
        mdl.classList?.add('show')

        mdl.style.display = 'block'
        mdl.style.backgroundColor = 'rgba(0,0,0,.7)'

        setReference(getParams('reference'))

        return () => {
            bdy.classList?.remove('modal-open')
            mdl.classList?.remove('show')

        }
    }, [getParams])
    const handlePlay = () => {
        handleClose()
        bet?.type === 'sportsbook' ?
            navigate(stringHelper.getLocalizedPath(currentLanguage, '/sportsbook'))
            :
            navigate(stringHelper.getLocalizedPath(currentLanguage, `/casino/games/${bet?.game?.slug}`))
    }

    useEffect(() => {
        console.log('bet = ', bet)
        if (bet?.type === 'sportsbook') {
            // console.log(bet?.details?.action_details?.events)
            setEvents(bet?.details?.events || [])
        }
    }, [bet])

    const [result, setResult] = useState(null);

    useEffect(() => {

        const allResulted = events.every(evt => evt.result !== null);

        if (allResulted)
            setResult(events.every(evt => evt.result === 'win') ? 'win' : 'lose')
        else
            setResult(null)

        if (events?.length <= 0)
            setResult(null)


    }, [events])


    // const handleBetToChat = () => CLIPBOARD_HELPER.copy(`${bet.type || 'casino'}:#${bet.id}`)

    const handleBetToChat = () => {
        const safeText = encodeURIComponent(`${bet.type || 'casino'}:#${bet.id}`);
        CLIPBOARD_HELPER.copy(safeText);
    };
    const handleCopyLink = () => {
        console.log('window.location.url = ', window.location.href)
        CLIPBOARD_HELPER.copy(window.location.href || '')
    }

    return (
        <div
            className="modal fade"
            id="gamebet-modal"
            onClick={handleClose}
        >

            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal__content" onClick={e => e.stopPropagation()}>
                        {
                            loading ? <Loading/> :
                                bet?.id ?
                                    <>
                                        <div className="modal__head">
                                            <h6 className="modal__title">{t('bet-detail.bet')}</h6>
                                            <button
                                                className="modal__close"
                                                type="button"
                                                onClick={handleClose}
                                            >
                                                <SvgIcon id={'x'}/>
                                            </button>
                                        </div>
                                        <div className="bet">
                                            <div className="bet__head">
                                                <h6 className="bet__game">{bet?.type === 'sportsbook' ? 'Sportsbook' : bet?.game?.name} </h6>

                                                {
                                                    bet?.type === 'casino' ?
                                                        <Link
                                                            to={stringHelper.getLocalizedPath(currentLanguage, `/providers/${bet?.game?.game_provider?.identifier}`)}
                                                            className="link-underline">{bet?.type !== 'sportsbook' ? `(${bet?.game?.game_provider?.name})` : ''}</Link>
                                                        :
                                                        null
                                                }
                                                <div className="bet__id">
                                                    <span># {bet?.id}</span>

                                                    <Tooltip className="tooltip-me" id="copy-tooltip"/>

                                                    <button
                                                        onClick={handleCopyLink}
                                                        data-tooltip-id="copy-tooltip"
                                                        data-tooltip-content={t('bet-detail.copy-link')}
                                                        data-tooltip-place="top"
                                                        type="button"
                                                    >
                                                        <SvgIcon id={'copy'}/>
                                                    </button>


                                                    <Tooltip className="tooltip-me" id="chat-tooltip"/>

                                                    <button
                                                        onClick={handleBetToChat}
                                                        type="button"
                                                        data-tooltip-id="copy-tooltip"
                                                        data-tooltip-content={t('bet-detail.copy-chat-link')}
                                                        data-tooltip-place="top"
                                                    >
                                                        <SvgIcon id={'link'}/>
                                                    </button>
                                                </div>


                                                <div className="bet__placed">
                                                    <span className="bet__by">{t('bet-detail.placed-by')}</span>
                                                    <span
                                                        className="chat__user d-flex align-items-center justify-content-center">
                                                         <Tooltip className="tooltip-me" anchorSelect={`#next-rank`}>
                                                            <span className="xtable__coin gap-2">
                                                                {/*<RankIcon icon={bet?.customer?.ranki}/>*/}
                                                                {bet?.customer.rank?.toUpperCase()}
                                                            </span>
                                                         </Tooltip>

                                                        {
                                                            bet?.customer?.ranki &&
                                                            <span id="next-rank" className="d-flex gap-2">
                                                                <RankIcon icon={bet?.customer?.ranki}/>
                                                        </span>
                                                        }
                                                        <Link
                                                            to={bet?.customer?.is_public ? stringHelper.getModalPathStatistics('statistics', bet?.customer?.username, searchParams) : ''}
                                                            className="chat__name" type="button">

                                                            {
                                                                bet?.customer?.is_public ?
                                                                    bet?.customer?.username :
                                                                    '******'
                                                            }t


                                                        </Link>
                                                      </span>
                                                    <p>{moment.unix(bet?.timestamp).format('MMMM Do YYYY, H:mm:ss a')}</p>
                                                </div>


                                                {/*casino bets*/}
                                                {
                                                    bet?.type === 'sportsbook' ?
                                                        <>
                                                            <div className="bet__date-wrap">
                                                                {
                                                                    result !== null ?
                                                                        <span
                                                                            className={`bet__status bet__status--${result}`}>
                                                                                    {t(`bet-detail.${result}`)}

                                                                    </span> : null
                                                                }

                                                                <div
                                                                    className="d-flex w-100 align-items-center justify-content-between">
                                                                            <span className="bet__date">
                                                                                {moment.unix(bet.timestamp).format('YYYY-MM-DD HH:mm:ss')}
                                                                            </span>

                                                                </div>
                                                            </div>
                                                            {
                                                                events?.map(event => (
                                                                    <div key={event.id} className="bet__content">

                                                                        <div className="bet__tickets">
                                                                            <div className="bet__ticket">

                                                                                <div
                                                                                    className="bet__odds d-flex align-items-center justify-content-between">
                                                                                    {/*<span>{t('bet-detail.tournament')}</span>*/}
                                                                                    <span>{event?.tournamentName}</span>
                                                                                </div>


                                                                                <span
                                                                                    className="w-100 d-flex align-items-center justify-content-between">
                                                                                    <div>
                                                                                        <i className="ti ti-shirt-sport"/>{" "}
                                                                                        <span>{event?.marketName}</span>
                                                                                    </div>
                                                                                    <span
                                                                                        className="d-flex gap-2 align-items-center">
                                                                                        <SvgIcon extra={'mini-icon'}
                                                                                                 id={event?.sportName?.toLowerCase()}/>
                                                                                        {event?.sportName}
                                                                                    </span>
                                                                                </span>
                                                                                <div
                                                                                    className="bet__odds d-flex align-items-center justify-content-between">
                                                                                    <span>{event?.teamHomeName} - {event?.teamAwayName}</span>
                                                                                </div>

                                                                                <div
                                                                                    className="bet__odds d-flex align-items-center justify-content-start justify-content-between gap-2">
                                                                                    <div
                                                                                        className="gap-2 d-flex align-items-center">
                                                                                        {
                                                                                            event?.result &&
                                                                                            <SvgIcon extra={'mini-icon'}
                                                                                                     id={event?.result === 'win' ? 'ti-check' : 'ti-x'}/>
                                                                                        }

                                                                                        <span>{event?.outcomeName}</span>
                                                                                    </div>

                                                                                    <span>{event?.odds}</span>

                                                                                </div>

                                                                                {
                                                                                    event?.eventStatus ?

                                                                                        <div
                                                                                            className="bet__odds d-flex align-items-center justify-content-between">
                                                                                            <span>{t('bet-detail.time')}</span>
                                                                                            <span
                                                                                                className="d-flex align-items-center gap-2">
                                                                                        {event?.eventStatus}
                                                                                                {
                                                                                                    event?.eventClock?.matchTime &&
                                                                                                    <span
                                                                                                        className="d-flex align-items-center gap-2">
                                                                                                {` ${event?.eventClock?.matchTime?.split(':')[0]} '`}

                                                                                                        {
                                                                                                            !event?.result &&
                                                                                                            <div
                                                                                                                className="live-match-animate"/>
                                                                                                        }
                                                                                                </span>
                                                                                                }

                                                                                    </span>
                                                                                        </div>

                                                                                        : null
                                                                                }


                                                                                {
                                                                                    event?.teamHomeScore || event?.teamAwayScore ?
                                                                                        <div
                                                                                            className="bet__odds d-flex align-items-center justify-content-between">
                                                                                            <span>{t('bet-detail.score')}</span>
                                                                                            <span>({event?.teamHomeScore || 0}-{event?.teamAwayScore || 0})</span>
                                                                                        </div>
                                                                                        : null
                                                                                }

                                                                            </div>

                                                                        </div>

                                                                    </div>
                                                                ))
                                                            }
                                                            <div className="bet__content invoice">
                                                                <ul className="bet__invoice">
                                                                    <li>
                                                                        <span>{t('bet-detail.odds')}</span>
                                                                        <div className="xtable__coin">{bet?.odds}</div>
                                                                    </li>
                                                                    <li>
                                                                        <span>{t('bet-detail.stake')}</span>
                                                                        <div className="xtable__coin gap-2">
                                                                            {bet?.wallet_amount}
                                                                            <InstrumentIcon code={bet.wallet_currency}/>
                                                                        </div>
                                                                    </li>

                                                                    <li>
                                                                        <span>{t('bet-detail.payout')}</span>
                                                                        <div className="xtable__coin gap-2">
                                                                            {Big(bet?.odds || 0).times(bet?.wallet_amount || 0).toFixed(8)}
                                                                            <InstrumentIcon code={bet.wallet_currency}/>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </>

                                                        :
                                                        <ul className="bet__info">
                                                            <li>
                                                                <span>{t('bet-detail.amount')}</span>
                                                                <div className="xtable__coin">
                                                                    <InstrumentIcon code={bet?.wallet_currency}/>
                                                                    {Big(bet?.wallet_amount || 0).toFixed(8)}
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <span>{t('bet-detail.multiplier')}</span>
                                                                <div
                                                                    className="xtable__text">x{Big(bet?.multiplier || 0).toFixed(2)}</div>
                                                            </li>
                                                            <li>
                                                                <span>{t('bet-detail.payout')}</span>
                                                                <div className="xtable__coin xtable__coin--green">
                                                                    <InstrumentIcon code={bet?.wallet_currency}/>
                                                                    {Big(bet?.wallet_income || 0).toFixed(8)}
                                                                </div>
                                                            </li>
                                                        </ul>

                                                }
                                            </div>

                                            <FormButton
                                                label={bet?.type === 'sportsbook' ? 'Sportsbook' : bet?.game?.name}
                                                loading={false}
                                                disabled={false}
                                                onClick={handlePlay}
                                            />
                                        </div>
                                    </>
                                    :
                                    <NoData/>
                        }
                    </div>
                </div>
            </div>
        </div>

    )

}

export default BetDetailModal
